import { Drawer, Tabs } from "antd";
import { Loader } from "Components/General/Loader";
import { I18N_NS } from "Config/i18n";
import React from "react";
import { useTranslation } from "react-i18next";
import { BCFViewerComments } from "./BCFViewerComments";
import { BCFViewerModel } from "./BCFViewerModel";
import { BCFViewerTopicInfo } from "./BCFViewerTopicInfo";

interface BCFViewerDrawerProps {
  onClose: () => void;
  visible: boolean;
  loading: boolean;
  topic: API_BcfTopic;
}

export const BCFViewerDrawer: React.FC<BCFViewerDrawerProps> = ({ onClose, visible, loading, topic }) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  return (
    <Drawer
      title={topic?.title}
      placement="right"
      closable={true}
      onClose={onClose}
      open={visible}
      getContainer={() => document.querySelector(".bcf-modal .ant-modal-container")}
      style={{ position: "absolute" }}
      size="large"
      zIndex={1014}
      className="bcf-drawer"
    >
      {loading ? (
        <Loader />
      ) : (
        <Tabs
          items={[
            { key: "info", label: t("Topic Information"), children: <BCFViewerTopicInfo topic={topic} /> },
            { key: "comments", label: t("Comments"), children: <BCFViewerComments /> },
            { key: "model", label: t("Model"), children: <BCFViewerModel /> },
          ]}
        />
      )}
    </Drawer>
  );
};
